import { Component } from "react";
import { isChunkLoadError, reloadOnceForChunkError } from "@/utils/chunkLoadRecovery";

// React.lazy turns a failed import into a render error. Without this boundary that unmounts the tree
// and leaves the black page background. A reload fetches the bundle from the deploy that just shipped.
export default class ChunkLoadErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error)) reloadOnceForChunkError();
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
